import { defineSlotRecipe } from '@chakra-ui/react';
import { checkboxAnatomy } from '@chakra-ui/react/anatomy';

export const checkboxSlotRecipe = defineSlotRecipe({
  className: 'chakra-checkbox',
  slots: checkboxAnatomy.keys(),
  base: {
    control: {
      _checked: {
        bg: 'button.primary',
        borderColor: 'button.primary',
        _hover: {
          bg: 'button.primary',
          borderColor: 'button.primary',
        },
      },
      _focusVisible: {
        outline: '2px solid',
        outlineColor: 'border.action',
        outlineOffset: '2px',
      },
    },
  },
  variants: {
    variant: {
      subtle: {},
      solid: {},
      primary: {
        control: {
          borderRadius: 'sm',
          borderWidth: '1px',
          borderColor: 'border.tertiary',
          width: '18px',
          height: '18px',
          bg: 'surface.input',
          _checked: {
            bg: 'defaultSafety.primary',
            borderColor: 'border.primary',
            _hover: {
              bg: 'defaultSafety.primary',
              borderColor: 'border.primary',
            },
          },
        },
      },
    },
    size: {
      xs: {},
      sm: {},
      md: {},
      lg: {},
    },
  },
  defaultVariants: {
    size: 'md',
    variant: 'primary',
  },
});
